// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { itemDetailSchema } from '@/items/api/types';
import { z } from 'zod';

/**
 * Schema for the get item API response.
 * Includes the complete item data and metadata about the request.
 */
const itemResponseSchema = z
  .object({ data: itemDetailSchema, metadata: responseMetadataSchema })
  .transform(({ data, ...response }) => ({ ...response, item: data }));

type ItemResponse = z.infer<typeof itemResponseSchema>;

/**
 * Fetches a single item's details from the API.
 * Returns the item including fields, accounting, and BOM data.
 */
export async function getItem(key: string): Promise<ItemResponse> {
  const url = `/v1/catalog/item/${key}`;
  const response = await api.get(url);
  return parseResponse(itemResponseSchema, response.data, {
    schemaName: 'Item',
    endpoint: url,
  });
}
